import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import Markdown from '@/components/markdown';
import { HelperCore } from '@/common/dependencies';
import { getFormattedResult } from '@shared/store/chat';
import Anchor from '../Anchor';

const McpChatText = observer((props) => {
  const {
    className = '',
    children,
    event,
  } = props;

  if(typeof children != "string" || !children?.length){
    return null;
  }

  // 包含图片，避免闪烁
  const markdownList = HelperCore.splitMarkdownByImages(children);

  return (
    <div className={`${className}`} data-id={event?.planStepId}>
      {
        markdownList.length > 1
        ? (
          <>
            {
              // 不应该有引用
              markdownList.map((item, index) => {
                return (
                  <Markdown
                    key={`md_img_${index}`}
                    text={getFormattedResult(item, {}, true)}
                    components={{
                      a: _props => (
                        <Anchor
                          {..._props}
                        />
                      ),
                    }}
                  />
                )
              })
            }
          </>
        )
        : (
          <Markdown 
            text={children}
            components={{
              a: _props => (
                <Anchor
                  {..._props}
                />
              ),
            }}
            />
        )
      }
    </div>
  )
  
  // return (
  //   <div className={`text-16px leading-28px whitespace-pre-wrap ${className}`}>
  //     {
  //       typeof children == "string"
  //       ? children.replace(/\n+/, '\n')
  //       : children
  //     }
  //   </div>
  // )
});
export default McpChatText;